// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var mapWrapper = "Map-module--mapWrapper--W0cdG";
export var element = "Map-module--element--87FfK";